const selectors = {
  count: 'data-cart-count',
};

class Totals {
  constructor(el) {
    this.section = el;
    this.counts = this.section.querySelectorAll(`[${selectors.count}]`);
    this.cartCount = null;
    this.listen();
  }

  listen() {
    document.addEventListener('theme:cart:change', (event) => {
      this.cartCount = event.detail.cartCount;
      this.update();
    });
  }

  update() {
    if (this.cartCount !== null) {
      this.counts.forEach((count) => {
        count.setAttribute(selectors.count, this.cartCount);
        count.innerHTML = this.cartCount < 10 ? `${this.cartCount}` : '9+';
      });
    }
  }
}
const headerTotals = {
  onLoad() {
    new Totals(this.container);
  },
};

export default headerTotals;
